export default __webpack_public_path__ + "static/media/goshen7.33ed01ed.jpg";